var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c("el-input", {
        attrs: {
          value: _vm.txtSurchargeTerms,
          placeholder: _vm.disabled
            ? ""
            : _vm.$t("SeaExport.DoubleClickToAddExtraChargeClause"),
          type: "textarea",
          rows: 4
        },
        nativeOn: {
          dblclick: function($event) {
            _vm.selectSurchargeTermsDialog.rowData =
              _vm.job.surchargeTerms || []
            _vm.selectSurchargeTermsDialog.visible = true
          }
        }
      }),
      _c("select-surcharge-terms-dialog", {
        attrs: {
          visible: _vm.selectSurchargeTermsDialog.visible,
          "job-uuid": _vm.job.uuid,
          "row-data": _vm.selectSurchargeTermsDialog.rowData,
          disabled: _vm.disabled,
          "append-to-body": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectSurchargeTermsDialog, "visible", $event)
          },
          callback: _vm.handleSurchargeTerms
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }